import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './legacy';
import './styles.css';

// Legacy-App (Lift-and-Shift aus public/index.html). Phase B-1.
// StrictMode bewusst aus — Legacy-Code würde Effects doppelt feuern (z.B. der
// Fetch-Override-Setup), das verursacht Doppel-Logins/Doppel-Fetches.
// Sobald wir in Phase B-2 die Effects sauber gemacht haben → wieder einschalten.
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
